import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Trace = lazy(() => import('./Trace'))

export const EburyRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--reconciliation']}>
    <Route index element={<Index />} />
    <Route path=':id' element={<Trace />} />
  </SubRouter>
))
